import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import AdventureCard from '../../../components/AdventureCard';
import FIRSTAIDIMAGES from '../../../assets/designSystem/icons/firstAid';
import SIGNSANDSYMPTOMSIMAGES from '../../../assets/designSystem/icons/signsAndSymptoms';
import KitoMascot from '../../../components/Mascot';

export default function SectionOne({ mascot, question, definition, bannerImage, video, symptoms }) {
  const { t } = useTranslation();

  const getVideoId = (url) => {
    if (!url) return null;
    const regExp = /(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&]+)/;
    const match = url.match(regExp);
    return match ? match[1] : url;
  };

  const videoId = getVideoId(t(video));
  return (
    <div className="definition__container">
      <KitoMascot image={mascot} textVariant="title">
        {t(question)}
      </KitoMascot>
      {videoId ? (
        <div className="video__container">
          <iframe
            width="100%"
            height="100%"
            src={`https://www.youtube.com/embed/${videoId}`}
            title={t('staticPages.firstAidChild.videoTitle')}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      ) : (
        <>
          <img
            alt={t('staticPages.firstAidChild.definitionImageAlt')}
            src={symptoms ? SIGNSANDSYMPTOMSIMAGES[bannerImage] : FIRSTAIDIMAGES[bannerImage]}
            className="definition__banner"
          />
          <AdventureCard text={t(definition)} />
        </>
      )}
      <div />
    </div>
  );
}

SectionOne.defaultProps = {
  bannerImage: null,
  video: null,
};

SectionOne.propTypes = {
  question: PropTypes.string.isRequired,
  definition: PropTypes.string.isRequired,
  bannerImage: PropTypes.string,
  video: PropTypes.string,
};
